module.exports = __webpack_public_path__ + "img/daq_small-min.4a77dc22.png";